







import {Component, Vue} from 'vue-property-decorator';
import StoresBody from "@/components/stores/StoresBody.vue";
import GlobalHeader from "@/components/GlobalHeader.vue";

@Component({
    components: {StoresBody, GlobalHeader}
})
export default class Stores extends Vue {

}
